import React, { FC, useEffect } from 'react';
import { Table, Button } from 'antd';
import styles from './AnnotationStandards.module.scss';
import { AnnotationStandard, fetchAnnotationStandards } from './annotationStandards.slice';
import { RootState } from '../../../rootReducer';
import { AppDispatch } from '../../../store';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import AnnotatioStandardActionColumn from './AnotationStandardActionColumn';

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    render: (text: string) => <a>{text}</a>
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description'
  },
  {
    title: 'Version',
    dataIndex: 'version',
    key: 'version'
  },
  {
    title: 'Standard body',
    key: 'standardBody',
    dataIndex: 'standardBody'
  },
  {
    title: 'Released',
    key: 'released',
    dataIndex: 'released',
    render: (param: boolean) => (param === true ? 'Yes' : 'No')
  },
  {
    title: 'Released date',
    key: 'releaseDate',
    dataIndex: 'releaseDate',
    render: (param: Date) => (param != null ? new Date(param).toLocaleDateString() : '/')
  },
  {
    title: 'Deprecated',
    key: 'deprecated',
    dataIndex: 'deprecated',
    render: (param: boolean) => (param === true ? 'Yes' : 'No')
  },
  {
    title: 'Deprecation date',
    key: 'deprecationDate',
    dataIndex: 'deprecationDate',
    render: (param: Date) => (param != null ? new Date(param).toLocaleDateString() : '/')
  },
  {
    title: 'Actions',
    key: 'action',
    render: (record: any) => <AnnotatioStandardActionColumn record={record} />
  }
];

type AnnotationStandardsProps = {
  annotationStandards: Array<AnnotationStandard>;
  isLoading: boolean;
  currentPage: number;
  totalNumber: number;
  size: number;
  onGetStandards: (newPage: number, size: number, init?: boolean) => void;
};

const AnnotationStandards: FC<AnnotationStandardsProps & RouteComponentProps> = ({
  isLoading,
  annotationStandards,
  onGetStandards,
  history,
  currentPage,
  totalNumber,
  size
}) => {
  useEffect(() => {
    onGetStandards(1, size, true);
  }, [onGetStandards, size]);

  const goToCreateAnnotationStandard = () => {
    history.push('/annotation-manager/create-annotation');
  };

  const footer = () => `Total rows: ${totalNumber}`;

  return (
    <div className={styles.tableContainer}>
      <h1 className='mainheader'>Annotation standards</h1>
      <Button className={styles.addFindingType} onClick={() => goToCreateAnnotationStandard()}>
        Create Annotation Standard
      </Button>
      <Table
        scroll={{ y: 460 }}
        dataSource={annotationStandards}
        columns={columns}
        loading={isLoading}
        rowKey='id'
        footer={footer}
        pagination={{
          current: currentPage,
          total: totalNumber,
          pageSize: size,
          onChange: (page: number) => {
            onGetStandards(page, size);
          },
          onShowSizeChange: (current: number, size: number) => {
            onGetStandards(1, size);
          }
        }}
      />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  annotationStandards: state.annotationStandards.annotationStandards,
  isLoading: state.annotationStandards.isLoading,
  currentPage: state.annotationStandards.currentPage,
  totalNumber: state.annotationStandards.totalNumberOfTurbines,
  size: state.annotationStandards.size
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  onGetStandards: (newPage: number, size: number, init: boolean = false) => dispatch(fetchAnnotationStandards(init, size, newPage))
});

export default connect(mapStateToProps, mapDispatchToProps)(AnnotationStandards);
